const TEAM_MANAGEMENT_ROLES = new Set(['owner', 'manager', 'captain']);
const TEAM_MEETUP_MANAGEMENT_ROLES = new Set([
  'owner',
  'manager',
  'captain',
  'organizer',
]);

function isAdminUser(user) {
  return ['admin', 'superadmin'].includes(user?.role || '');
}

export function getCurrentHubTeamRole(team, currentUser) {
  const currentUserNumber = currentUser?.userNumber || '';

  if (!currentUserNumber) {
    return '';
  }

  const member = Array.isArray(team?.members)
    ? team.members.find((entry) => entry?.userNumber === currentUserNumber)
    : null;

  return typeof member?.role === 'string' ? member.role : '';
}

export function canCurrentUserManageHubTeam(team, currentUser) {
  return (
    isAdminUser(currentUser) ||
    TEAM_MANAGEMENT_ROLES.has(getCurrentHubTeamRole(team, currentUser))
  );
}

export function canCurrentUserManageHubTeamMeetups(team, currentUser) {
  return (
    isAdminUser(currentUser) ||
    TEAM_MEETUP_MANAGEMENT_ROLES.has(getCurrentHubTeamRole(team, currentUser))
  );
}
